function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { DisplayTaxAndGlLocationsSelector, FormattedCustomersAddressesListSelector, InventoryRegionFilterSelector, InventoryStoresTableDataSelector, SelectedCustomerAddressSelector, SelectedInventoryStoreDetailsSelector, SelectedInventoryStoreNameSelector, SelectedServiceIdentifierSelector, ServiceIdentifiersListSelector, ShoppingCartItemDetailsLocationCodesSelector, ShoppingCartSelector } from '../../../../../../reducers/selectors/products.order.selectors';
import { setSelectedItemId } from '../../../../../../reducers/actions/customer.addresses.actions';
import { fetchProductOrderCustomerInventory, retrieveCustomerAddresses, setSelectedCustomerAddress, setInventoryRegionFilter, setSelectedInventoryStores, setSelectedServiceIdentifier } from '../../../../../../reducers/actions/products.order.actions';
import { MetadataOptionsForCodeValuesWithoutPlaceholderSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { loadCodeTables } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { INVENTORY_CATEGORY_CODE } from '../../../../../../customercare.constants';
import clone from 'ramda/src/clone';
import { calculateOrderQuote } from '../../../../../../reducers/actions/products.wizard.actions';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
var TAX_LOCATION_CONSTANTS = {
  CUSTOMER_ADDRESS: 2,
  DEFAULT: 1,
  NPA_NXX: 3,
  STORE_LOCATION: 4
};
var TaxAndGeneralLedgerController = /*#__PURE__*/function () {
  function TaxAndGeneralLedgerController($ngRedux, $state, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, TaxAndGeneralLedgerController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      callCalculateOrderQuote: true,
      closeSelectCustomerAddressAndServiceIdentifierDialog: this.closeSelectCustomerAddressAndServiceIdentifierDialog.bind(this),
      closeSelectCustomerAddressDialog: this.closeSelectCustomerAddressDialog.bind(this),
      closeSelectServiceIdentifierDialog: this.closeSelectServiceIdentifierDialog.bind(this),
      closeSelectStorePopupDialog: this.closeSelectStorePopupDialog.bind(this),
      CustomerCareKeys: CustomerCareKeys,
      onInventoryRegionFilterChanged: this.onInventoryRegionFilterChanged.bind(this),
      openSelectCustomerAddressAndServiceIdentifierDialog: this.openSelectCustomerAddressAndServiceIdentifierDialog.bind(this),
      openSelectCustomerAddressDialog: this.openSelectCustomerAddressDialog.bind(this),
      openSelectServiceIdentifierDialog: this.openSelectServiceIdentifierDialog.bind(this),
      retrieveAddresses: this.retrieveAddresses.bind(this),
      saveSelectCustomerAddressAndServiceIdentifierDialog: this.saveSelectCustomerAddressAndServiceIdentifierDialog.bind(this),
      saveSelectCustomerAddressDialog: this.saveSelectCustomerAddressDialog.bind(this),
      selectedCustomerAddress: null,
      selectedServiceIdentifier: null,
      showCustomerAddressAndServiceIdentifierPicker: false,
      showCustomerAddressPicker: false,
      showServiceIdentifierPicker: false,
      showStoreLocationPicker: false,
      uiNotificationService: uiNotificationService
    });
    Promise.all(loadCodeTables(this.$ngRedux.getState(), this.$ngRedux.dispatch, [CODES.InventoryRegion, CODES.Stores])).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
  }
  return _createClass(TaxAndGeneralLedgerController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          displayTaxAndGlLocations: DisplayTaxAndGlLocationsSelector(store),
          formattedCustomerAddressesList: FormattedCustomersAddressesListSelector(store),
          inventoryRegions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.InventoryRegion, store),
          locationCodes: ShoppingCartItemDetailsLocationCodesSelector(store),
          selectedCustomerAddress: SelectedCustomerAddressSelector(store),
          selectedInventoryRegion: InventoryRegionFilterSelector(store),
          selectedInventoryStore: SelectedInventoryStoreDetailsSelector(store),
          selectedInventoryStoreName: SelectedInventoryStoreNameSelector(store),
          selectedServiceIdentifier: SelectedServiceIdentifierSelector(store),
          serviceIdentifiersList: ServiceIdentifiersListSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          storesTableData: InventoryStoresTableDataSelector(store)
        };
      };
      var controllerActions = {
        calculateOrderQuote: calculateOrderQuote,
        fetchProductOrderCustomerInventory: fetchProductOrderCustomerInventory,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        setInventoryRegionFilter: setInventoryRegionFilter,
        setSelectedCustomerAddress: setSelectedCustomerAddress,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setSelectedItemId: setSelectedItemId,
        setSelectedServiceIdentifier: setSelectedServiceIdentifier
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.selectCustomerAddressPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.selectCustomerAddressPopupApi = event.api;
        }
      };
      this.selectStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.selectStorePopupApi = api;
        }
      };
      this.selectServiceIdentifierPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.selectServiceIdentifierPopupApi = event.api;
        }
      };
      this.selectCustomerAddressAndServiceIdentifierPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.selectCustomerAddressAndServiceIdentifierPopupApi = event.api;
        }
      };
      this.retrieveAddresses();
      this.retrieveServiceIdentifiers();
    }
  }, {
    key: "openSelectCustomerAddressDialog",
    value: function openSelectCustomerAddressDialog() {
      var _this3 = this;
      this.customerAddresses = clone(this.state.formattedCustomerAddressesList);
      if (this.customerAddresses.length === TAX_LOCATION_CONSTANTS.DEFAULT) {
        this.selectedCustomerAddress = this.customerAddresses[0];
      } else if (this.customerAddresses.length > TAX_LOCATION_CONSTANTS.DEFAULT && this.selectedCustomerAddress === null) {
        this.selectedCustomerAddress = this.state.selectedCustomerAddress;
      }
      this.$timeout(function () {
        _this3.selectCustomerAddressPopupApi.open();
      });
    }
  }, {
    key: "closeSelectCustomerAddressDialog",
    value: function closeSelectCustomerAddressDialog() {
      var _this4 = this;
      this.$timeout(function () {
        _this4.selectCustomerAddressPopupApi.close();
      });
    }
  }, {
    key: "saveSelectCustomerAddressDialog",
    value: function saveSelectCustomerAddressDialog() {
      this.actions.setSelectedCustomerAddress(this.selectedCustomerAddress);
      this.calculateOrderQuoteWithTaxAndGL();
      this.closeSelectCustomerAddressDialog();
    }
  }, {
    key: "openSelectStoreDialog",
    value: function openSelectStoreDialog() {
      var _this5 = this;
      this.showSelectStorePopup = true;
      this.$timeout(function () {
        _this5.selectStorePopupApi.open();
      });
    }
  }, {
    key: "closeSelectStorePopupDialog",
    value: function closeSelectStorePopupDialog(isApplyChanges, selectedStore) {
      this.showSelectStorePopup = false;
      if (isApplyChanges) {
        this.actions.setSelectedInventoryStores(selectedStore);
        this.calculateOrderQuoteWithTaxAndGL();
      }
      this.selectStorePopupApi.close();
    }
  }, {
    key: "openSelectServiceIdentifierDialog",
    value: function openSelectServiceIdentifierDialog() {
      var _this6 = this;
      this.serviceIdentifiersListData = clone(this.state.serviceIdentifiersList);
      if (this.serviceIdentifiersListData.length === TAX_LOCATION_CONSTANTS.DEFAULT) {
        this.selectedServiceIdentifier = this.serviceIdentifiersListData[0];
      } else if (this.serviceIdentifiersListData.length > TAX_LOCATION_CONSTANTS.DEFAULT && this.selectedServiceIdentifier === null) {
        this.selectedServiceIdentifier = this.state.selectedServiceIdentifier;
      }
      this.$timeout(function () {
        _this6.selectServiceIdentifierPopupApi.open();
      });
    }
  }, {
    key: "closeSelectServiceIdentifierDialog",
    value: function closeSelectServiceIdentifierDialog() {
      var _this7 = this;
      this.$timeout(function () {
        _this7.selectServiceIdentifierPopupApi.close();
      });
    }
  }, {
    key: "saveSelectedServiceIdentifier",
    value: function saveSelectedServiceIdentifier() {
      this.actions.setSelectedServiceIdentifier(this.selectedServiceIdentifier);
      this.calculateOrderQuoteWithTaxAndGL();
      this.closeSelectServiceIdentifierDialog();
    }
  }, {
    key: "onInventoryRegionFilterChanged",
    value: function onInventoryRegionFilterChanged(region) {
      this.actions.setInventoryRegionFilter(region);
    }
  }, {
    key: "openSelectCustomerAddressAndServiceIdentifierDialog",
    value: function openSelectCustomerAddressAndServiceIdentifierDialog() {
      var _this8 = this;
      this.customerAddresses = clone(this.state.formattedCustomerAddressesList);
      this.serviceIdentifiersListData = clone(this.state.serviceIdentifiersList);
      if (this.customerAddresses.length === TAX_LOCATION_CONSTANTS.DEFAULT) {
        this.selectedCustomerAddress = this.customerAddresses[0];
      } else if (this.customerAddresses.length > TAX_LOCATION_CONSTANTS.DEFAULT && this.selectedCustomerAddress === null) {
        this.selectedCustomerAddress = this.state.selectedCustomerAddress;
      }
      if (this.serviceIdentifiersListData.length === TAX_LOCATION_CONSTANTS.DEFAULT) {
        this.selectedServiceIdentifier = this.serviceIdentifiersListData[0];
      } else if (this.serviceIdentifiersListData.length > TAX_LOCATION_CONSTANTS.DEFAULT && this.selectedServiceIdentifier === null) {
        this.selectedServiceIdentifier = this.state.selectedServiceIdentifier;
      }
      this.$timeout(function () {
        _this8.selectCustomerAddressAndServiceIdentifierPopupApi.open();
      });
    }
  }, {
    key: "closeSelectCustomerAddressAndServiceIdentifierDialog",
    value: function closeSelectCustomerAddressAndServiceIdentifierDialog() {
      var _this9 = this;
      this.$timeout(function () {
        _this9.selectCustomerAddressAndServiceIdentifierPopupApi.close();
      });
    }
  }, {
    key: "saveSelectCustomerAddressAndServiceIdentifierDialog",
    value: function saveSelectCustomerAddressAndServiceIdentifierDialog() {
      this.actions.setSelectedCustomerAddress(this.selectedCustomerAddress);
      this.actions.setSelectedServiceIdentifier(this.selectedServiceIdentifier);
      this.calculateOrderQuoteWithTaxAndGL();
      this.closeSelectCustomerAddressAndServiceIdentifierDialog();
    }
  }, {
    key: "retrieveAddresses",
    value: function retrieveAddresses() {
      var _this10 = this;
      this.actions.retrieveCustomerAddresses(this.state.currentCustomerId, false).catch(function (error) {
        _this10.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "retrieveServiceIdentifiers",
    value: function retrieveServiceIdentifiers() {
      this.actions.fetchProductOrderCustomerInventory(this.state.currentCustomerId, INVENTORY_CATEGORY_CODE.LOGICAL);
    }
  }, {
    key: "calculateOrderQuoteWithTaxAndGL",
    value: function calculateOrderQuoteWithTaxAndGL() {
      if (this.state.displayTaxAndGlLocations) {
        this.showCustomerAddressPicker = this.state.displayTaxAndGlLocations.showCustomerAddressPicker;
        this.showServiceIdentifierPicker = this.state.displayTaxAndGlLocations.showServiceIdentifierPicker;
        this.showStoreLocationPicker = this.state.displayTaxAndGlLocations.showStoreLocationPicker;
        this.showCustomerAddressAndServiceIdentifierPicker = this.state.displayTaxAndGlLocations.showCustomerAddressAndServiceIdentifierPicker;
      }
      var taxAndGlPayload = Object.assign({}, this.showCustomerAddressPicker && this.selectedCustomerAddress && {
        AddressId: this.selectedCustomerAddress.addressId
      }, this.showServiceIdentifierPicker && this.selectedServiceIdentifier && {
        ServiceIdentifierValue: this.selectedServiceIdentifier.SerialNumber
      }, this.showStoreLocationPicker && this.state.selectedInventoryStore && {
        StoreId: convertStringToNumber(this.state.selectedInventoryStore.Value)
      }, this.showCustomerAddressAndServiceIdentifierPicker && this.selectedCustomerAddress && this.selectedServiceIdentifier && {
        AddressId: this.selectedCustomerAddress.addressId,
        ServiceIdentifierValue: this.selectedServiceIdentifier.SerialNumber
      });
      var order = {
        customerId: this.state.currentCustomerId,
        shoppingCart: this.state.shoppingCart,
        orderTaxLocation: taxAndGlPayload
      };
      if (this.uiNotificationService.numActiveToasts()) {
        this.uiNotificationService.clear();
      }
      if (this.state.locationCodes.length === Object.keys(taxAndGlPayload).length) {
        this.actions.calculateOrderQuote(order);
      }
    }
  }]);
}();
export default {
  template: require('./tax.and.general.ledger.location.html'),
  bindings: {},
  controller: TaxAndGeneralLedgerController
};